<template>
  <div class="wrapper">
  </div>
</template>

<script>
  export default {
      data() {
          return {

          }
      }
  }
</script>

<style lang="less" scoped>
  @import '../assets/css/search.less';
</style>



// WEBPACK FOOTER //
// search.vue?1c84ee7e